import React from 'react'
import type { UserInfo } from '../types'

interface UserInfoCardProps {
  userInfo: UserInfo
}

export const UserInfoCard: React.FC<UserInfoCardProps> = ({ userInfo }) => {
  console.log('card usserinfo', userInfo)
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">
        Información para la cita:
      </h3>
      <div className="space-y-3">
        <div className="flex items-start">
          <span className="text-gray-500 mr-2">👤</span>
          <div className="flex w-full">
            <span className="text-sm font-medium text-gray-700 w-20 flex-shrink-0">
              Nombre:
            </span>
            <span className="text-sm text-gray-900">
              {userInfo.name || 'No especificado'}
            </span>
          </div>
        </div>

        <div className="flex items-start">
          <span className="text-gray-500 mr-2">📧</span>
          <div className="flex w-full">
            <span className="text-sm font-medium text-gray-700 w-20 flex-shrink-0">
              Email:
            </span>
            <span className="text-sm text-gray-900">{userInfo.email}</span>
          </div>
        </div>

        {userInfo.phone && (
          <div className="flex items-start">
            <span className="text-gray-500 mr-2">📱</span>
            <div className="flex w-full">
              <span className="text-sm font-medium text-gray-700 w-20 flex-shrink-0">
                Teléfono:
              </span>
              <span className="text-sm text-gray-900">{userInfo.phone}</span>
            </div>
          </div>
        )}

        {userInfo.primaryAddress && (
          <div className="flex items-start">
            <span className="text-gray-500 mr-2">📍</span>
            <div className="flex w-full">
              <span className="text-sm font-medium text-gray-700 w-20 flex-shrink-0">
                Dirección:
              </span>
              <span className="text-sm text-gray-900 break-words">
                {userInfo.primaryAddress}
              </span>
            </div>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-500 mt-4">
        Esta información se enviará automáticamente a Calendly para facilitar el
        agendamiento.
      </p>
    </div>
  )
}
